import { useLang } from "../../lib/i18n";

const WORDS_IT = [
  "Atelier Divine",
  "Alta Moda Sposa",
  "Sartorialità",
  "Su Appuntamento",
  "Lusso & Dettaglio",
  "Comiso",
];

const WORDS_EN = [
  "Atelier Divine",
  "Bridal Haute Couture",
  "Tailoring",
  "By Appointment",
  "Luxury & Detail",
  "Comiso",
];

export const Marquee = () => {
  const { lang } = useLang();
  const words = lang === "it" ? WORDS_IT : WORDS_EN;
  const row = [...words, ...words];
  return (
    <section
      data-testid="marquee-section"
      className="relative bg-ad-black border-y border-white/10 py-8 md:py-12 overflow-hidden"
    >
      <div className="flex whitespace-nowrap animate-marquee will-change-transform">
        {row.map((w, i) => (
          <span key={i} className="flex items-center">
            <span className="font-serif-display italic font-light text-4xl md:text-6xl text-white/90 px-8">
              {w}
            </span>
            <span className="text-gold text-3xl md:text-5xl">&#10022;</span>
          </span>
        ))}
      </div>
    </section>
  );
};
